var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "w-100 h-100 d-flex flex-column align-items-center justify-content-center",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.openFileUploadDialog($event)
        },
      },
    },
    [
      _vm.viewToRender === "default"
        ? _c("file-upload-default-view", {
            attrs: {
              "disable-g-drive-button": _vm.disableGdriveButton,
              showDropdown: _vm.showDropdown,
              "start-clicked": _vm.startClicked,
            },
            on: {
              "open-file-upload-dialog": function ($event) {
                return _vm.openFileUploadDialog($event)
              },
              "open-g-drive-dialog": _vm.openGdriveDialog,
              "open-drop-box-dialog": _vm.openDropboxDialog,
              "toggle-drop-down": _vm.toggleDropdown,
              startClicked: function ($event) {
                _vm.startClicked = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viewToRender === "upload-in-progress"
        ? _c("upload-in-progress-view", {
            attrs: {
              "disable-g-drive-button": _vm.disableGdriveButton,
              showDropdown: _vm.showDropdown,
              "start-clicked": _vm.startClicked,
            },
            on: {
              "open-file-upload-dialog": function ($event) {
                return _vm.openFileUploadDialog($event)
              },
              "open-g-drive-dialog": _vm.openGdriveDialog,
              "open-drop-box-dialog": _vm.openDropboxDialog,
              "toggle-drop-down": _vm.toggleDropdown,
              startClicked: function ($event) {
                _vm.startClicked = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viewToRender === "add-file"
        ? _c("add-file-view", {
            attrs: {
              "disable-g-drive-button": _vm.disableGdriveButton,
              showDropdown: _vm.showDropdown,
              "start-clicked": _vm.startClicked,
            },
            on: {
              "open-file-upload-dialog": function ($event) {
                return _vm.openFileUploadDialog($event)
              },
              "open-g-drive-dialog": _vm.openGdriveDialog,
              "open-drop-box-dialog": _vm.openDropboxDialog,
              "toggle-drop-down": _vm.toggleDropdown,
              startClicked: function ($event) {
                _vm.startClicked = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viewToRender === "file-added"
        ? _c("file-added-view", {
            attrs: {
              "disable-g-drive-button": _vm.disableGdriveButton,
              showDropdown: _vm.showDropdown,
              "start-clicked": _vm.startClicked,
            },
            on: {
              "open-file-upload-dialog": function ($event) {
                return _vm.openFileUploadDialog($event)
              },
              "open-g-drive-dialog": _vm.openGdriveDialog,
              "open-drop-box-dialog": _vm.openDropboxDialog,
              "toggle-drop-down": _vm.toggleDropdown,
              startClicked: function ($event) {
                _vm.startClicked = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viewToRender === "waiting-for-upload"
        ? _c("waiting-for-upload-view", { attrs: { files: _vm.files } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }